import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=b6bc6a74&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"
import style1 from "./basic.vue?vue&type=style&index=1&id=b6bc6a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc6a74",
  null
  
)

export default component.exports